/**
 * Verified Badge Component
 *
 * Shows a "Verified" badge for licensed credentials.
 * Indicates that the credential has been paid for and can be publicly verified.
 */

interface VerifiedBadgeProps {
  verificationHash?: string;
  className?: string;
  showLink?: boolean;
}

export function VerifiedBadge({ verificationHash, className = '', showLink = false }: VerifiedBadgeProps) {
  const badgeContent = (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 border border-primary-300 ${className}`}
      title="This is a verified, licensed credential"
    >
      <ShieldCheckIcon className="w-3.5 h-3.5" />
      Verified
    </span>
  );

  if (showLink && verificationHash) {
    return (
      <a
        href={`/verify/${verificationHash}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:opacity-80 transition-opacity"
      >
        {badgeContent}
      </a>
    );
  }

  return badgeContent;
}

function ShieldCheckIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11.99 10.5l-3.54 3.54a1 1 0 01-1.415 0l-1.77-1.77a1 1 0 111.414-1.415l1.063 1.063 2.833-2.833a1 1 0 111.414 1.415z"
        clipRule="evenodd"
      />
    </svg>
  );
}
